var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}},[_c('path',{attrs:{"d":"m283 699-43-43 240-240 240 240-43 43-197-197-197 197Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }